class DoubtSolution {
  constructor(doubtSolution) {
    this.solutionUid = doubtSolution.uid;
    this.state = doubtSolution.state;
    this.language = doubtSolution.language;
    this.createdAt = doubtSolution.created_at;
    this.learnersReport = doubtSolution.learners_report;
    this.video = doubtSolution.video;
    this.isReviewed = doubtSolution?.is_reviewed;
    this.likePercentage = doubtSolution.rating?.likes_percent;
    this.totalRatings = doubtSolution.rating?.total;
    this.user = doubtSolution.user;
    this.doubt = { doubt: doubtSolution.doubt };
    this.status = doubtSolution.solution_status;
  }
}

const getEntityData = (data) => {
  const doubt = new DoubtSolution(data);
  return doubt;
};

export default {
  DoubtSolution,
  getEntityData
};
